import type { DataDrivenPropertyValueSpecification } from 'maplibre-gl';

import type { MapThemeColors } from '../utils/color-scale';
import type { ChoroplethLayerConfig } from './ChoroplethConfig';

export function buildFillExpression(
  config: ChoroplethLayerConfig,
  data: Record<string, number>,
  colorScale: (value: number) => string,
  colors: MapThemeColors
): DataDrivenPropertyValueSpecification<string> | string {
  const fallbackFill = colors.noDataFill;

  if (Object.keys(data).length === 0) {
    return fallbackFill;
  }

  // Built incrementally: a `match` expression has a variable arm count, which
  // the spec's union type cannot describe, so it is assembled loose and
  // narrowed on return.
  const expr: unknown[] = [
    'match',
    ['to-string', ['get', config.propertyName]],
  ];
  Object.entries(data).forEach(([name, val]) => {
    if (!name || name === '' || val === undefined || val === null) return;
    expr.push(name, colorScale(val) ?? fallbackFill);
  });
  expr.push(fallbackFill);
  return expr as DataDrivenPropertyValueSpecification<string>;
}
